(() => {
  const roots = document.querySelectorAll('[data-tempo-fiber-guide]');

  roots.forEach((root) => {
    if (root.dataset.fiberEnhanced === 'true') return;
    root.dataset.fiberEnhanced = 'true';
    root.classList.add('is-enhanced');

    const campaignKeys = ['gclid', 'fbclid', 'ttclid', 'msclkid'];
    const incomingParams = new URLSearchParams(window.location.search);

    root.querySelectorAll('[data-tempo-product-link]').forEach((link) => {
      try {
        const target = new URL(link.getAttribute('href'), window.location.origin);
        incomingParams.forEach((value, key) => {
          if ((key.startsWith('utm_') || campaignKeys.includes(key)) && !target.searchParams.has(key)) {
            target.searchParams.set(key, value);
          }
        });
        link.href = target.toString();
      } catch (error) {
        /* Keep the configured product URL if it cannot be parsed. */
      }
    });

    const readingProgress = root.querySelector('[data-reading-progress]');
    let progressFrame = null;

    const updateReadingProgress = () => {
      progressFrame = null;
      if (!readingProgress) return;

      const rootTop = root.getBoundingClientRect().top + window.scrollY;
      const distance = Math.max(root.offsetHeight - window.innerHeight, 1);
      const progress = Math.min(Math.max((window.scrollY - rootTop) / distance, 0), 1);
      readingProgress.style.transform = `scaleX(${progress})`;
    };

    if (readingProgress) {
      const requestProgressUpdate = () => {
        if (progressFrame !== null) return;
        progressFrame = window.requestAnimationFrame(updateReadingProgress);
      };

      updateReadingProgress();
      window.addEventListener('scroll', requestProgressUpdate, { passive: true });
      window.addEventListener('resize', requestProgressUpdate);
    }

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    const activateTab = (tab, moveFocus = false) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });

      if (moveFocus) tab.focus();
    };

    if (tabs.length && panels.length) {
      const initial = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      activateTab(initial);

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          const columns = window.matchMedia('(min-width: 701px) and (max-width: 990px)').matches ? 2 : 1;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowDown') nextIndex = (index + columns) % tabs.length;
          if (event.key === 'ArrowUp') nextIndex = (index - columns + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex !== index) {
            event.preventDefault();
            activateTab(tabs[nextIndex], true);
          }
        });
      });
    }

    const navLinks = Array.from(root.querySelectorAll('[data-fiber-nav]'));
    const currentChapter = root.querySelector('[data-fiber-current]');
    const observedSections = navLinks
      .map((link) => root.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    if ('IntersectionObserver' in window && observedSections.length) {
      const sectionObserver = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (!visible) return;

        navLinks.forEach((link) => {
          const active = link.getAttribute('href') === `#${visible.target.id}`;
          link.classList.toggle('is-active', active);
          if (active) {
            link.setAttribute('aria-current', 'location');
            if (currentChapter) currentChapter.textContent = link.textContent.trim();
          }
          else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: [0, 0.2, 0.5] });

      observedSections.forEach((section) => sectionObserver.observe(section));
    }

    const stickyCta = root.querySelector('[data-sticky-cta]');
    const productReveal = root.querySelector('#where-tempo-fits');

    if (stickyCta && productReveal && 'IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver(([entry]) => {
        const hasReachedProduct = entry.isIntersecting || entry.boundingClientRect.top < 0;
        stickyCta.classList.toggle('is-visible', hasReachedProduct);
      }, { rootMargin: '0px 0px -20% 0px', threshold: 0 });

      revealObserver.observe(productReveal);
    }
  });
})();
